(() => {
  if (window.lbNativeContent) { window.lbNativeContent.refresh(); return; }
  const phone = matchMedia('(max-width:768px)'), applied = new Map();
  let queued = false, detailRetry = false;
  const detailLeases = new WeakMap(), detailHandoffs = new WeakMap();
  const classApplied = new Map();
  const parsedRules = new WeakMap();
  function parsedFields(rule) {
    const text = rule.textContent, cached = parsedRules.get(rule);
    if (cached && cached.text === text) return cached.fields;
    const fields = JSON.parse(text);
    parsedRules.set(rule, {text, fields});
    return fields;
  }
  const rangeApplied = new Map(), rangeUnloaded = new WeakSet();
  const rangeAttribute = 'data-lb-range-active';
  function rangeUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return false;
    try { const url = new URL(value, location.href); return /^https?:$/.test(url.protocol) && !url.username && !url.password && /^(?:https?:)?\/\//i.test(value.trim()); } catch (_) { return false; }
  }
  function releaseRange(node) {
    if (!rangeApplied.has(node)) return;
    if (node.getAttribute(rangeAttribute) === 'true') node.removeAttribute(rangeAttribute);
    rangeApplied.delete(node);
  }
  const rangeMetadata = new Map(), rangeForeignMetadata = new WeakMap();
  const rangeFacts = ['data-lb-range-desktop-empty','data-lb-native-mobile-fallback'];
  function releaseRangeMetadata(node) {
    const entries = rangeMetadata.get(node);
    if (!entries) return;
    entries.forEach((entry, key) => {
      if (node.getAttribute(key) !== entry.value) return;
      if (entry.has) node.setAttribute(key, entry.original); else node.removeAttribute(key);
    });
    rangeMetadata.delete(node);
  }
  function newsletterRangePath(node, section, owner, field, record) {
    if (!record || record.rangeActive !== true || record.kind !== 'text' || field !== 'boutique_heading' || owner !== section.id.slice('shopify-section-'.length) || typeof record.mobile !== 'string') return false;
    let heading = node;
    if (node.tagName === 'LB-NATIVE-VALUE') heading = node.parentElement;
    else if (node.tagName === 'LB-NATIVE-DESKTOP' || node.tagName === 'LB-NATIVE-MOBILE') heading = node.parentElement?.parentElement;
    if (!heading || heading.tagName !== 'H2' || heading.getAttribute('data-lb-range-parent-scope') !== 'newsletter-title-section-heading' || heading.getAttribute('data-lb-range-parent-section') !== owner || heading.getAttribute(rangeAttribute) !== 'true') return false;
    const block = heading.getAttribute('data-lb-range-parent-block'), host = heading.parentElement;
    if (!block || heading.id !== 'NewsletterHeading-' + owner + '-' + block || !host || host.tagName !== 'DIV' || host.getAttribute('data-lb-element') !== block || !section.isConnected || rangeUnloaded.has(section) || heading.closest('[id^="shopify-section-"]') !== section) return false;
    const forbidden = ['data-lb-native-owner','data-lb-native-field','data-lb-native-field-secondary','data-lb-range-owner','data-lb-range-field','data-lb-nc-owner'];
    if (forbidden.some(key => host.hasAttribute(key)) || blockKeys.some(key => host.hasAttribute(key) && host.getAttribute(key) !== block)) return false;
    if (!host.parentElement || !ownedPath(host.parentElement, section, owner) || !mediaTarget(host.parentElement, section, owner, field, 'src')) return false;
    for (let current = host.parentElement; current && current !== section; current = current.parentElement) {
      if ((current.hasAttribute('data-lb-range-owner') && current.getAttribute('data-lb-range-owner') !== owner) || (current.hasAttribute('data-lb-range-field') && current.getAttribute('data-lb-range-field') !== field) || current.hasAttribute('data-lb-native-field-secondary')) return false;
    }
    const values = Array.from(heading.children), value = values[0];
    if (values.length !== 1 || value.tagName !== 'LB-NATIVE-VALUE' || value.getAttribute(rangeAttribute) !== 'true' || Array.from(heading.childNodes).some(child => child.nodeType === 3 && /[^\t\n\f\r ]/.test(child.nodeValue))) return false;
    const roles = Array.from(value.children);
    if (roles.length !== 2 || roles.filter(child => child.tagName === 'LB-NATIVE-DESKTOP').length !== 1 || roles.filter(child => child.tagName === 'LB-NATIVE-MOBILE').length !== 1 || Array.from(value.childNodes).some(child => child.nodeType === 3 && child.nodeValue.length)) return false;
    const direct = target => (target.getAttribute('data-lb-native-owner') === owner && target.getAttribute('data-lb-native-field') === field) || (target.getAttribute('data-lb-range-owner') === owner && target.getAttribute('data-lb-range-field') === field);
    if (!direct(heading) || !direct(value) || ![heading,value,...roles].includes(node)) return false;
    return [heading,...Array.from(heading.querySelectorAll('*'))].every(child => {
      if (child !== heading && (child.getAttribute('id') || '').startsWith('shopify-section-')) return false;
      if (child.hasAttribute('data-lb-native-field-secondary')) return false;
      return ['data-lb-native-owner','data-lb-range-owner','data-lb-nc-owner',...blockKeys].every(key => !child.hasAttribute(key) || child.getAttribute(key) === owner) && ['data-lb-native-field','data-lb-range-field','data-lb-nc-src'].every(key => !child.hasAttribute(key) || child.getAttribute(key) === field);
    });
  }
  function rangePath(node, section, owner, field, record) {
    return (ownedPath(node, section, owner) && mediaTarget(node, section, owner, field, 'src')) || newsletterRangePath(node, section, owner, field, record);
  }
  function rangeIdentity(node, section, owner, field, record) {
    const nativeOwner = node.getAttribute('data-lb-native-owner'), nativeField = node.getAttribute('data-lb-native-field');
    const rangeOwner = node.getAttribute('data-lb-range-owner'), rangeField = node.getAttribute('data-lb-range-field');
    if (!((nativeOwner === owner && nativeField === field) || (rangeOwner === owner && rangeField === field))) return false;
    if ((nativeOwner !== null && nativeOwner !== owner) || (nativeField !== null && nativeField !== field) || (rangeOwner !== null && rangeOwner !== owner) || (rangeField !== null && rangeField !== field) || node.hasAttribute('data-lb-native-field-secondary')) return false;
    if (node.closest('[id^="shopify-section-"]') !== section || !rangePath(node, section, owner, field, record)) return false;
    for (let current = node; current && current !== section; current = current.parentElement) {
      const ownOwner = current.getAttribute('data-lb-range-owner'), ownField = current.getAttribute('data-lb-range-field');
      if ((ownOwner !== null && ownOwner !== owner) || (ownField !== null && ownField !== field)) return false;
    }
    return true;
  }
  function ownHeadingEmpty(node, section, owner, field, kind, record) {
    if (node.matches(':empty')) return true;
    let shell = node;
    const hero = owner === section.id.slice('shopify-section-'.length) && node.getAttribute(rangeAttribute) === 'true' && ((field === 'title' && kind === 'textarea' && node.tagName === 'H2' && node.matches('.hero__title')) || (field === 'subheading' && kind === 'text' && node.tagName === 'DIV' && node.matches('.hero__subtitle')));
    if (hero && Array.from(node.children).some(child => child.tagName === 'DIV')) {
      const only = (parent, tag, className) => {
        if (!parent) return null;
        const children = Array.from(parent.childNodes), elements = children.filter(child => child.nodeType === 1);
        if (elements.length !== 1 || children.some(child => child.nodeType === 3 && /[^\t\n\f\r ]/.test(child.nodeValue))) return null;
        const child = elements[0];
        if (child.tagName !== tag || (className && !child.matches('.' + className)) || !ownedPath(child, section, owner) || !mediaTarget(child, section, owner, field, 'src')) return null;
        if (['data-lb-range-owner','data-lb-range-field','data-lb-native-owner','data-lb-native-field','data-lb-native-field-secondary'].some(key => child.hasAttribute(key)) && !rangeIdentity(child, section, owner, field, record)) return null;
        return child;
      };
      const cropper = only(node, 'DIV', 'animation-cropper'), contents = only(cropper, 'DIV', 'animation-contents');
      const value = only(contents, 'LB-NATIVE-VALUE', null);
      if (!value || !rangeIdentity(value, section, owner, field, record)) return false;
      shell = contents;
    }
    const children = Array.from(shell.childNodes);
    const elements = children.filter(child => child.nodeType === 1);
    if (children.some(child => child.nodeType === 3 && child.nodeValue.length && !(elements.length === 1 && elements[0].matches('lb-native-value') && !/[^\t\n\f\r ]/.test(child.nodeValue)))) return false;
    let value = shell;
    if (elements.length === 1 && elements[0].matches('lb-native-value')) {
      value = elements[0];
      if (!rangeIdentity(value, section, owner, field, record)) return false;
    } else if (elements.some(child => !child.matches('lb-native-desktop,lb-native-mobile'))) return false;
    const desktops = Array.from(value.children).filter(child => child.matches('lb-native-desktop'));
    const mobiles = Array.from(value.children).filter(child => child.matches('lb-native-mobile'));
    if (desktops.length !== 1 || mobiles.length !== 1 || value.children.length !== 2) return false;
    if (Array.from(value.childNodes).some(child => child.nodeType === 3 && child.nodeValue.length)) return false;
    const desktop = desktops[0];
    if (!rangePath(desktop, section, owner, field, record) || !rangePath(mobiles[0], section, owner, field, record)) return false;
    if (Array.from(value.querySelectorAll('[data-lb-native-owner],[data-lb-native-field],[data-lb-range-owner],[data-lb-range-field]')).some(child => !rangeIdentity(child, section, owner, field, record))) return false;
    if (desktop.hasAttribute('data-lb-range-owner') || desktop.hasAttribute('data-lb-range-field')) {
      if (!rangeIdentity(desktop, section, owner, field, record)) return false;
    }
    return desktop.matches(':empty');
  }
  function refreshRangeMetadata(desired) {
    rangeMetadata.forEach((entries, node) => {
      entries.forEach((entry, key) => {
        if (desired.get(node)?.has(key)) return;
        if (node.getAttribute(key) === entry.value) {
          if (entry.has) node.setAttribute(key, entry.original); else node.removeAttribute(key);
        }
        entries.delete(key);
      });
      if (!entries.size) rangeMetadata.delete(node);
    });
    rangeObserver.takeRecords();
    desired.forEach((values, node) => values.forEach((value, key) => {
      if (rangeForeignMetadata.get(node)?.has(key)) return;
      if (!rangeMetadata.has(node)) rangeMetadata.set(node, new Map());
      const entries = rangeMetadata.get(node);
      const entry = entries.has(key) ? entries.get(key) : {has:node.hasAttribute(key), original:node.getAttribute(key)};
      entry.value = value; entries.set(key, entry);
      if (node.getAttribute(key) !== value) node.setAttribute(key, value);
      rangeObserver.takeRecords();
    }));
  }
  function rangeRecords(records) {
    records.forEach(record => {
      if (record.type !== 'attributes') return;
      if (record.attributeName === rangeAttribute) rangeApplied.delete(record.target);
      if (rangeFacts.includes(record.attributeName)) {
        rangeMetadata.get(record.target)?.delete(record.attributeName);
        if (!rangeForeignMetadata.has(record.target)) rangeForeignMetadata.set(record.target, new Set());
        rangeForeignMetadata.get(record.target).add(record.attributeName);
      }
    });
    records.forEach(record => {
      if (record.type === 'childList') Array.from(record.removedNodes || []).forEach(removed => {
        Array.from(rangeApplied.keys()).forEach(node => { if (node === removed || removed.contains?.(node)) releaseRange(node); });
        Array.from(rangeMetadata.keys()).forEach(node => { if (node === removed || removed.contains?.(node)) releaseRangeMetadata(node); });
      });
    });
  }
  const rangeObserver = new MutationObserver(records => { rangeRecords(records); rangeObserver.takeRecords(); schedule(); });
  rangeObserver.observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:[rangeAttribute,...rangeFacts,'data-lb-range-parent-scope','data-lb-range-parent-block','data-lb-range-parent-section','data-lb-range-owner','data-lb-range-field','data-lb-native-desktop-present','data-lb-native-mobile-present','data-lb-native-wrapper-desktop','data-lb-native-wrapper-mobile','data-lb-native-optional-desktop','data-lb-native-optional-mobile','class','id','data-lb-native-content','data-lb-native-owner','data-lb-native-field','data-lb-native-field-secondary','data-lb-native-section','data-lb-nc-owner','data-lb-element','data-block-id','data-id']});
  function refreshRange() {
    rangeRecords(rangeObserver.takeRecords());
    rangeObserver.takeRecords();
    const desired = new Set(), metadataDesired = new Map(), contracts = new Map();
    document.querySelectorAll('script[data-lb-native-content]').forEach(rule => {
      const sectionId = rule.getAttribute('data-lb-native-section'), owner = rule.getAttribute('data-lb-native-owner');
      const section = ownRoot(rule);
      if (!owner || !section || !rule.isConnected || !section.contains(rule) || rangeUnloaded.has(section) || !ownedPath(rule, section, owner)) return;
      let fields; try { fields = parsedFields(rule); } catch (_) { return; }
      if (!Array.isArray(fields)) return;
      fields.forEach(field => {
        if (!field || typeof field !== 'object' || Array.isArray(field) || typeof field.field !== 'string' || !field.field.trim()) return;
        if (!contracts.has(section)) contracts.set(section, new Map());
        const owners = contracts.get(section);
        if (!owners.has(owner)) owners.set(owner, new Map());
        const entries = owners.get(owner);
        const key = field.field;
        if (entries.has(key)) entries.set(key, null);
        else entries.set(key, field);
      });
    });
    contracts.forEach((owners, section) => owners.forEach((fields, owner) => {
      section.querySelectorAll('lb-native-value,h1,h2,h3,h4,h5,h6,.hero__subtitle,.section-header,.image-wrap,.footer__logo,lb-native-presence,[data-lb-native-wrapper-desktop],[data-lb-native-optional-desktop]').forEach(node => {
        const key = node.getAttribute('data-lb-range-field') ?? node.getAttribute('data-lb-native-field'), field = fields.get(key);
        if (!field || field.rangeActive !== true || !rangeIdentity(node, section, owner, key, field)) return;
        const isImageWrapper = node.matches('.image-wrap,.footer__logo');
        const isText = ['text','textarea','richtext','inline_richtext','url','html'].includes(field.kind);
        if (isImageWrapper) {
          if (field.kind !== 'image_picker' || !Object.prototype.hasOwnProperty.call(field,'original') || !(field.original === null || rangeUrl(field.original)) || !rangeUrl(field.mobile)) return;
          if (Array.from(node.querySelectorAll('[data-lb-native-owner],[data-lb-native-field],[data-lb-range-owner],[data-lb-range-field]')).some(child => !rangeIdentity(child, section, owner, key))) return;
        } else if (!isText || typeof field.mobile !== 'string' || !Object.prototype.hasOwnProperty.call(field,'original') || !(field.original === null || typeof field.original === 'string')) return;
        if (node.matches('lb-native-presence') && !['data-lb-native-desktop-present','data-lb-native-mobile-present'].every(attr => ['true','false'].includes(node.getAttribute(attr)))) return;
        if (node.hasAttribute('data-lb-native-wrapper-desktop') && !['data-lb-native-wrapper-desktop','data-lb-native-wrapper-mobile'].every(attr => ['true','false'].includes(node.getAttribute(attr)))) return;
        if (node.hasAttribute('data-lb-native-optional-desktop') && !['data-lb-native-optional-desktop','data-lb-native-optional-mobile'].every(attr => ['true','false'].includes(node.getAttribute(attr)))) return;
        if (node.hasAttribute(rangeAttribute) && node.getAttribute(rangeAttribute) !== 'true') return;
        desired.add(node);
        const facts = new Map();
        if (node.matches('h1,h2,h3,h4,h5,h6,.hero__subtitle,.section-header')) facts.set('data-lb-range-desktop-empty', String(ownHeadingEmpty(node, section, owner, key, field.kind, field)));
        if (isImageWrapper) facts.set('data-lb-native-mobile-fallback', String(field.original === null && rangeUrl(field.mobile)));
        if (facts.size) metadataDesired.set(node, facts);
      });
      section.querySelectorAll('lb-native-image').forEach(node => {
        const key = node.getAttribute('data-lb-native-field'), field = fields.get(key);
        if (node.getAttribute('data-lb-native-owner') !== owner || !field || field.kind !== 'image_picker' || field.rangeActive !== true || !Object.prototype.hasOwnProperty.call(field,'original') || !(field.original === null || rangeUrl(field.original)) || !rangeUrl(field.mobile)) return;
        if (!ownedPath(node, section, owner) || !mediaTarget(node, section, owner, key, 'src', true)) return;
        for (let parent = node.parentElement; parent && parent !== section; parent = parent.parentElement) if (parent.matches('lb-native-image')) return;
        if (node.getAttribute('data-lb-native-field-secondary')) return;
        if (Array.from(node.querySelectorAll('*')).some(child => child.matches('lb-native-image') || !ownedPath(child, section, owner) || !mediaTarget(child, section, owner, key, 'src'))) return;
        desired.add(node);
      });
    }));
    Array.from(rangeApplied.keys()).forEach(node => { if (!desired.has(node)) releaseRange(node); });
    rangeObserver.takeRecords();
    desired.forEach(node => {
      if (rangeApplied.has(node) || node.hasAttribute(rangeAttribute)) return;
      node.setAttribute(rangeAttribute, 'true');
      rangeApplied.set(node, true);
      rangeObserver.takeRecords();
    });
    refreshRangeMetadata(metadataDesired);
  }
  document.addEventListener('shopify:section:unload', event => { rangeUnloaded.add(event.target); refreshRange(); });
  document.addEventListener('shopify:section:load', event => { rangeUnloaded.delete(event.target); schedule(); });
  function detailOwns(node,key) {
    const owns=window.lbPartDesign?.owns; if(!owns) return false;
    if(owns(node,key)) return true;
    if(key!=='html' && key!=='textContent') return false;
    const walker=document.createTreeWalker(node,NodeFilter.SHOW_TEXT); let text;
    while((text=walker.nextNode())) if(owns(text,'text')) return true;
    return key==='html' && Array.from(node.querySelectorAll('*')).some(child => ['href','src','srcset','alt','placeholder','value'].some(attr=>owns(child,attr)));
  }
  const normalize = value => String(value ?? '').trim();
  const protectedText = 'script,style,svg,[data-lb-design-rule],.product__price,.product__price-savings,.grid-product__price,.cart__price,.cart__item-price,.cart__subtotal,[data-product-price],[data-product-select],[name="id"],.variant-input-wrap';
  const safeLink = value => { const text = normalize(value); return /^(?:javascript|data|vbscript):/i.test(text) ? null : text || null; };
  const file = value => { try { return decodeURIComponent(new URL(value, location.href).pathname.split('/').pop()); } catch (_) { return ''; } };
  const blockKeys = ['data-lb-element','data-block-id','data-id'];
  function ownedPath(node, section, owner) {
    for (let current = node; current && current !== section; current = current.parentElement) {
      if ((current.getAttribute('id') || '').startsWith('shopify-section-')) return false;
      for (const key of ['data-lb-nc-owner'].concat(blockKeys)) {
        const value = current.getAttribute(key);
        if (value && value !== owner) return false;
      }
    }
    return node === section || section.contains(node);
  }
  function mediaTarget(node, section, owner, field, key, requireField = false) {
    if (!section || !ownedPath(node, section, owner)) return false;
    let bound = false;
    for (let current = node; current && current !== section; current = current.parentElement) {
      const nativeOwner = current.getAttribute('data-lb-native-owner');
      if (nativeOwner && nativeOwner !== owner) return false;
      const nativeField = current.getAttribute('data-lb-native-field');
      const secondary = current.getAttribute('data-lb-native-field-secondary');
      if (nativeField || secondary) {
        if (nativeField !== field && secondary !== field) return false;
        bound = true;
      }
      const attrField = current.getAttribute('data-lb-nc-' + key);
      if (attrField !== null) {
        if (attrField !== field) return false;
        bound = true;
      }
    }
    return !requireField || bound;
  }
  function mediaContext(node) {
    const section = node.closest('[id^="shopify-section-"]');
    if (!section) return null;
    let owner = section.id.slice('shopify-section-'.length);
    for (let current = node; current && current !== section; current = current.parentElement) {
      const value = current.getAttribute('data-lb-native-owner') || current.getAttribute('data-lb-nc-owner') || blockKeys.map(key => current.getAttribute(key)).find(Boolean);
      if (value) { owner = value; break; }
    }
    return {section, owner, field: node.getAttribute('data-lb-native-field')};
  }
  function ownRoot(rule) {
    const sectionId = rule.getAttribute('data-lb-native-section');
    const owner = rule.getAttribute('data-lb-native-owner');
    if (!sectionId || !owner || !rule.isConnected) return null;
    const section = rule.closest('[id^="shopify-section-"]');
    if (!section || section.id !== 'shopify-section-' + sectionId || !section.isConnected || rangeUnloaded.has(section) || !ownedPath(rule, section, owner)) return null;
    for (let node = rule; node && node !== section; node = node.parentElement) {
      const nativeOwner = node.getAttribute('data-lb-native-owner');
      if (nativeOwner && nativeOwner !== owner) return null;
    }
    return section;
  }
  function ownerScope(rule) {
    const section = ownRoot(rule);
    if (!section) return [];
    if (rule.dataset.lbNativeOwner === rule.dataset.lbNativeSection) return [section];
    const id = CSS.escape(rule.dataset.lbNativeOwner);
    const targets = Array.from(section.querySelectorAll('[data-lb-element="' + id + '"],[data-block-id="' + id + '"],[data-id="' + id + '"],[data-lb-nc-owner="' + id + '"]')).filter(node => ownedPath(node, section, rule.dataset.lbNativeOwner));
    return targets.filter(node => !targets.some(parent => parent !== node && parent.contains(node)));
  }
  function scopeTargets(scope, selector, rule, markers = false) {
    const owner = rule.dataset.lbNativeOwner;
    const section = ownRoot(rule);
    const targets = Array.from(scope.querySelectorAll(selector));
    if (markers && scope.matches(selector)) targets.unshift(scope);
    return targets.filter(node => {
      if (!section || !ownedPath(node, section, owner)) return false;
      if (markers || owner === rule.dataset.lbNativeSection) return true;
      for (let current = node; current && current !== section; current = current.parentElement) {
        if (blockKeys.some(key => current.getAttribute(key) === owner)) return true;
      }
      return false;
    });
  }
  const original = (node, key) => applied.get(node)?.has(key) ? applied.get(node).get(key).original : (key === 'text' ? node.nodeValue : key === 'html' ? node.innerHTML : key === 'textContent' ? node.textContent : node.getAttribute(key));
  function refresh() {
    queued = false;
    refreshRange();
    const desired = new Map(), detailSkipped = new Map();
    let leaseScope = null;
    const skipDetail = (node, key, context) => {
      if (!detailOwns(node, key)) return false;
      if (!detailSkipped.has(node)) detailSkipped.set(node, new Set());
      detailSkipped.get(node).add(key);
      if (context && detailContextCurrent(node, key, context)) {
        const handoffs = detailHandoffs.get(node);
        handoffs?.delete(key);
        if (handoffs && !handoffs.size) detailHandoffs.delete(node);
        if (!detailLeases.has(node)) detailLeases.set(node, new Map());
        detailLeases.get(node).set(key, context);
      }
      return true;
    };
    // Native checkbox layout tokens change independently, preserving provider-added classes.
    const classDesired = new Map();
    document.querySelectorAll('[data-lb-native-classes-desktop]').forEach(node => {
      const desktop = (node.dataset.lbNativeClassesDesktop || '').split(/\s+/).filter(Boolean);
      const mobile = (node.dataset.lbNativeClassesMobile || '').split(/\s+/).filter(Boolean);
      const selected = new Set(phone.matches ? mobile : desktop);
      classDesired.set(node, new Map(Array.from(new Set(desktop.concat(mobile)), token => [token, selected.has(token)])));
    });
    classApplied.forEach((tokens, node) => {
      tokens.forEach((entry, token) => {
        if (!node.isConnected || !classDesired.get(node)?.has(token)) {
          if (node.isConnected && node.classList.contains(token) === entry.value) {
            const value = classDesired.has(node) ? false : entry.original;
            node.classList.toggle(token, value);
            entry.value = value;
          }
          // Retain the original snapshot while even an empty contract exists.
          if (!node.isConnected || !classDesired.has(node)) tokens.delete(token);
        }
      });
      if (!tokens.size) classApplied.delete(node);
    });
    classDesired.forEach((tokens, node) => {
      if (!classApplied.has(node)) classApplied.set(node, new Map());
      const saved = classApplied.get(node);
      tokens.forEach((value, token) => {
        const entry = saved.has(token) ? saved.get(token) : {original: node.classList.contains(token)};
        entry.value = value; saved.set(token, entry); node.classList.toggle(token, value);
      });
    });
    // Move the one canonical image/text pair; never clone interactive descendants.
    document.querySelectorAll('[data-lb-native-feature-layout-desktop]').forEach(row => {
      const images=Array.from(row.children).find(n=>n.classList.contains('feature-row__images'));
      const text=Array.from(row.children).find(n=>n.classList.contains('feature-row__text'));
      if(!images || !text) return;
      const side=row.dataset[phone.matches?'lbNativeFeatureLayoutMobile':'lbNativeFeatureLayoutDesktop'];
      if(side==='left' && images.nextElementSibling!==text) row.insertBefore(images,text);
      else if(side==='right' && text.nextElementSibling!==images) row.insertBefore(images,text.nextSibling);
    });
    document.querySelectorAll('[data-lb-native-filter-style-desktop]').forEach(node => {
      node.dataset.style = phone.matches ? node.dataset.lbNativeFilterStyleMobile : node.dataset.lbNativeFilterStyleDesktop;
      const enabled = node.dataset[phone.matches ? 'lbNativeFilterEnabledMobile' : 'lbNativeFilterEnabledDesktop'] === 'true';
      if (!enabled && document.getElementById('FilterDrawer')?.classList.contains('drawer--is-open')) window.theme?.FilterDrawer?.close();
    });
    document.querySelectorAll('parallax-image[data-lb-native-parallax]').forEach(parallax => {
      const enabled = () => parallax.dataset[phone.matches ? 'lbNativeParallaxMobile' : 'lbNativeParallaxDesktop'] === 'true';
      const image = parallax.querySelector('[data-parallax-image]'); if (!image) return;
      if (!parallax.lbNativeGuard && typeof parallax.init === 'function') {
        const init = parallax.init, scroll = parallax.scrollHandler;
        parallax.init = function() { if (!enabled()) { this.isActive = false; return; } return init.apply(this, arguments); };
        if (typeof scroll === 'function') parallax.scrollHandler = function() { if (!enabled()) { this.isActive = false; return; } return scroll.apply(this, arguments); };
        parallax.lbNativeGuard = true;
      }
      const mode = phone.matches ? 'Mobile' : 'Desktop', key = mode + ':' + enabled();
      image.dataset.angle = image.dataset['lbNativeAngle' + mode] || image.dataset.lbNativeAngleDesktop;
      parallax.dataset.lbNativeParallaxActive = String(enabled());
      if (parallax.lbNativeAppliedMode === key) return;
      parallax.lbNativeAppliedMode = key;
      clearTimeout(parallax.timeout); parallax.isActive = false;
      ['width','height','left','right','top','bottom','transform'].forEach(prop => image.style.removeProperty(prop));
      parallax.windowInnerHeight = window.innerHeight;
      if (parallax.parallaxImage && typeof parallax.init === 'function') parallax.init();
    });
    document.querySelectorAll('[data-lb-native-sticky-desktop]').forEach(header => {
      const d = phone.matches ? 'Mobile' : 'Desktop';
      const sticky = header.dataset['lbNativeSticky' + d] === 'true';
      const collectionHeader = document.querySelector('#CollectionHeaderSection[data-section-type="collection-header"][data-lb-native-collection-hero-desktop]');
      const hasCollectionHero = !collectionHeader || collectionHeader.dataset['lbNativeCollectionHero' + d] === 'true';
      const overlay = header.dataset['lbNativeOverlay' + d] === 'true' && hasCollectionHero;
      if (collectionHeader && hasCollectionHero) {
        const hero = collectionHeader.querySelector('.collection-hero');
        if (hero) { hero.classList.remove('loading', 'loading--delayed'); hero.classList.add('loaded'); }
      }
      header.dataset.sticky = String(sticky); header.dataset.overlay = String(overlay);
      header.closest('[data-section-type="header"]')?.querySelectorAll('details[data-hover]').forEach(node => { node.dataset.hover = header.dataset['lbNativeHover' + d]; });
      const wrapper = document.getElementById('HeaderWrapper'), toolbar = header.closest('[data-section-type="header"]')?.querySelector('.toolbar');
      if (wrapper && toolbar) {
        if (overlay && toolbar.parentElement !== wrapper) wrapper.insertBefore(toolbar, wrapper.firstChild);
        if (!overlay && toolbar.parentElement === wrapper) wrapper.parentElement.parentElement.insertBefore(toolbar, wrapper.parentElement);
        toolbar.classList.toggle('toolbar--transparent', overlay);
      }
      window.theme?.headerNav?.refreshResponsive(sticky, overlay);
    });
    const promoTouched = new Set();
    document.querySelectorAll('[data-lb-native-promo-position-mobile]').forEach(node => {
      const host = node.closest('.collapsible-content__inner');
      if (!host) return;
      const group = Array.from(host.querySelectorAll('.megamenu__mobile-promos[data-lb-native-promo-group]')).find(child => child.dataset.lbNativePromoGroup === node.dataset.lbNativePromoOwner);
      const list = Array.from(host.children).find(child => child.matches('ul.mobile-nav__sublist'));
      if (!group || !list) return;
      promoTouched.add(group);
      const before = phone.matches && node.dataset.lbNativePromoPositionMobile === 'before';
      let parent = group;
      if (before) {
        parent = Array.from(host.children).find(child => child.dataset.lbNativePromoBeforeGroup === node.dataset.lbNativePromoOwner);
        if (!parent) {
          parent = document.createElement('div');
          parent.className = 'megamenu__mobile-promos';
          parent.dataset.lbNativePromoBeforeGroup = node.dataset.lbNativePromoOwner;
          host.insertBefore(parent, list);
        }
      }
      const next = Array.from(parent.children).find(child => Number(child.dataset.lbNativePromoNumber) > Number(node.dataset.lbNativePromoNumber)) || null;
      if (node.parentElement === parent && (!next || node.nextElementSibling === next)) return;
      const active = document.activeElement;
      const preserve = active && node.contains(active);
      parent.insertBefore(node, next);
      if (preserve && active.isConnected && document.activeElement !== active) active.focus({preventScroll:true});
    });
    promoTouched.forEach(group => {
      group.dataset.lbNativeOptionalMobile = String(group.children.length > 0);
      group.dataset.lbNativePromoCount = String(group.children.length);
      const host = group.closest('.collapsible-content__inner');
      host?.querySelectorAll('[data-lb-native-promo-before-group]').forEach(before => { if (!before.children.length) before.remove(); else before.dataset.lbNativePromoCount = String(before.children.length); });
    });
    window.theme?.announcementBar?.refreshResponsive?.();
    document.querySelectorAll('[data-lb-native-popup]').forEach(node => node.lbNativePopup?.refreshResponsive(false));
    document.querySelectorAll('lb-native-video').forEach(pair => {
      const context = mediaContext(pair);
      if (!context || !context.field) return;
      const accepts = (node, key) => mediaTarget(node, context.section, context.owner, context.field, key);
      pair.querySelectorAll('lb-native-mobile [data-lb-native-media-src]').forEach(node => { if (!accepts(node,'src')) return; const source=node.dataset.lbNativeMediaSrc; if(phone.matches) { if(node.getAttribute('src')!==source) node.setAttribute('src',source); } else if(node.hasAttribute('src')) { if(node.tagName==='VIDEO') node.pause(); node.removeAttribute('src'); if(node.tagName==='VIDEO') node.load(); } });
      if(phone.matches) pair.querySelectorAll('lb-native-desktop video').forEach(node => { if (accepts(node,'src')) node.pause(); });
      pair.querySelectorAll('lb-native-desktop iframe').forEach(frame => { if (!accepts(frame,'src')) return; try { if(phone.matches) { const origin=new URL(frame.src,location.href).origin; const message=origin.includes('vimeo.com') ? {method:'pause'} : {event:'command',func:'pauseVideo',args:[]}; frame.contentWindow?.postMessage(JSON.stringify(message),origin); } } catch(_) {} });
    });
    const want = (node, key, value) => {
      if (skipDetail(node,key,leaseScope)) return;
      const handoffs = detailHandoffs.get(node), handoff = handoffs?.get(key);
      if (handoff) {
        // A foreign release stays rejected for this exact producer generation,
        // including observer/neighbor refreshes. Only a real Detail reacquisition
        // or invalidation of the captured own context retires that rejection.
        if (!detailContextCurrent(node, key, handoff.context)) {
          if (!leaseScope || !detailContextCurrent(node, key, leaseScope)) return;
          handoffs.delete(key);
        } else {
          if (handoff.rejected || node.getAttribute(key) !== handoff.original || !leaseScope || leaseScope.rule !== handoff.context.rule || leaseScope.config !== handoff.context.config || leaseScope.section !== handoff.context.section || leaseScope.scope !== handoff.context.scope || leaseScope.owner !== handoff.context.owner || leaseScope.field !== handoff.context.field) {
            handoff.rejected = true;
            return;
          }
          handoffs.delete(key);
        }
        if (!handoffs.size) detailHandoffs.delete(node);
      }
      if (!desired.has(node)) desired.set(node, new Map());
      desired.get(node).set(key, value);
    };
    document.querySelectorAll('script[data-lb-native-content]').forEach(rule => {
      let fields; try { fields = parsedFields(rule); } catch (_) { return; }
      if (!Array.isArray(fields) || !fields.length) return;
      const scopes = ownerScope(rule); if (!scopes.length) return;
      for (const scope of scopes) {
      const mediaSection = ownRoot(rule);
      for (const field of fields) {
        if (!field || typeof field !== 'object' || Array.isArray(field) || typeof field.field !== 'string' || !field.field.trim() || typeof field.kind !== 'string' || !field.kind.trim()) continue;
        const id = CSS.escape(field.field), owner = CSS.escape(rule.dataset.lbNativeOwner);
        leaseScope = {rule, section:mediaSection, scope, owner:rule.dataset.lbNativeOwner, field:field.field, config:rule.textContent};
        if (!phone.matches && !(field.kind === 'image_picker' && !field.original)) continue;
        const marked = scopeTargets(scope, '[data-lb-nc-owner="' + owner + '"]', rule, true);
        let handled = false;
        marked.forEach(node => ['href','placeholder','alt','title','aria-label','value'].forEach(attr => {
          if (node.getAttribute('data-lb-nc-' + attr) !== field.field) return;
          handled = true;
          want(node, attr, attr === 'href' ? safeLink(field.mobile) : normalize(field.mobile));
        }));
        const scoped = { querySelectorAll: selector => scopeTargets(scope, selector, rule), querySelector: selector => scopeTargets(scope, selector, rule)[0] || null };
        if (field.kind === 'image_picker') {
          const name = file(field.original || field.mobile);
          scoped.querySelectorAll('img').forEach(img => {
            if (!mediaTarget(img, mediaSection, rule.dataset.lbNativeOwner, field.field, 'src')) return;
            const marker=img.closest('lb-native-image'); if(!marker || (marker.dataset.lbNativeField !== field.field && marker.dataset.lbNativeFieldSecondary !== field.field) || marker.dataset.lbNativeOwner !== rule.dataset.lbNativeOwner) return;
            const sources = ['src','data-src','srcset','data-srcset'].map(key => original(img, key) || '').join(' ');
            if (!marker && (!name || !sources.includes(name) && !sources.includes(encodeURIComponent(name)))) return;
            if (!phone.matches) { if(marker?.dataset.lbNativeMobileFallback==='true') want(img,'style',(original(img,'style') || '')+';display:none!important'); return; }
            if (!field.mobile) { want(img,'style',(original(img,'style') || '')+';display:none!important'); return; }
            ['src','data-src'].forEach(key => { if (mediaTarget(img, mediaSection, rule.dataset.lbNativeOwner, field.field, key) && (key === 'src' || img.hasAttribute(key))) want(img,key,field.mobile); });
            ['srcset','sizes','data-srcset'].forEach(key => { if (mediaTarget(img, mediaSection, rule.dataset.lbNativeOwner, field.field, key) && (img.hasAttribute(key) || applied.get(img)?.has(key))) want(img,key,null); });
            if (field.mobileAlt !== undefined && mediaTarget(img, mediaSection, rule.dataset.lbNativeOwner, field.field, 'alt')) want(img,'alt',field.mobileAlt);
            img.closest('picture')?.querySelectorAll('source').forEach(source => { if (mediaTarget(source, mediaSection, rule.dataset.lbNativeOwner, field.field, 'srcset')) want(source,'srcset',field.mobile); });
          });
          // Unmarked background fallback removed: require an explicit image contract 17.
          // Unmarked background fallback removed: require an explicit image contract 18.
          continue;
        }
        if (field.kind === 'url') {
          // URL identity requires the explicit owner/field marker handled above.
          // Equal original hrefs cannot establish which setting owns an anchor.
          continue;
        }
        if (field.kind === 'video' || field.kind === 'video_url' || /video.*url|video_url/.test(field.field)) {
          if(Array.from(scoped.querySelectorAll('lb-native-video[data-lb-native-field="'+id+'"]')).some(pair => mediaTarget(pair, mediaSection, rule.dataset.lbNativeOwner, field.field, 'src', true))) continue;
          scoped.querySelectorAll('[data-lb-native-video-frame="true"]').forEach(container => { const provider=container.dataset.lbNativeVideoProvider,id=container.dataset.lbNativeVideoId; const frame=Array.from(container.querySelectorAll('iframe')).find(frame => mediaTarget(frame, mediaSection, rule.dataset.lbNativeOwner, field.field, 'src', true)); if (!frame) return; const url=provider==='youtube' ? 'https://www.youtube.com/embed/'+id+'?rel=0&showinfo=0&vq=720' : provider==='vimeo' ? 'https://player.vimeo.com/video/'+id : null; want(frame,'src',url); if(!url)want(frame,'style',(original(frame,'style') || '')+';display:none!important'); });
          const desktop = typeof field.original === 'object' ? field.original?.url : field.original;
          const mobile = typeof field.mobile === 'object' ? field.mobile?.url : field.mobile;
          if (desktop) scoped.querySelectorAll('video,source,iframe,[data-video-id]').forEach(node => {
            if (!mediaTarget(node, mediaSection, rule.dataset.lbNativeOwner, field.field, 'src', true)) return;
            const src = original(node,'src');
            if (src && (src === desktop || file(src) && file(src) === file(desktop))) want(node,'src',mobile || null);
            const type = node.dataset.type;
            if (type === 'youtube' || type === 'vimeo') {
              let videoId = ''; try { const url = new URL(mobile); videoId = type === 'youtube' ? url.searchParams.get('v') || url.pathname.split('/').pop() : url.pathname.split('/').pop(); } catch (_) {}
              if (videoId) {
                want(node,'data-video-id',videoId);
                node.querySelectorAll('iframe').forEach(frame => { if (!mediaTarget(frame, mediaSection, rule.dataset.lbNativeOwner, field.field, 'src', true)) return; const url = new URL(frame.src,location.href); url.pathname = '/'+(type === 'youtube' ? 'embed/' : 'video/')+videoId; want(frame,'src',url.href); });
              }
            }
          });
          continue;
        }
        if (field.kind === 'richtext' || field.kind === 'inline_richtext') {
          marked.forEach(node => {
            if (node.closest('lb-native-value') || node.querySelector('lb-native-value') || node.getAttribute('data-lb-nc-owner') !== rule.dataset.lbNativeOwner || node.getAttribute('data-lb-nc-html') !== field.field) return;
            if (Array.from(node.querySelectorAll('*')).some(child => !ownedPath(child, node, rule.dataset.lbNativeOwner) || ['data-lb-nc-text','data-lb-nc-html'].some(key => child.hasAttribute(key) && child.getAttribute(key) !== field.field))) return;
            if (normalize(original(node,'html')) === normalize(field.original)) want(node,'html',field.mobile || '');
          });
          continue;
        }
        if (field.field === 'lb_button_label') { scoped.querySelectorAll('[data-lb-native-buy-label]').forEach(node => { const button = node.closest('[data-add-to-cart]'); want(node,'data-default-text',field.mobile || ''); if (button && !button.disabled) want(node,'textContent',field.mobile || ''); }); continue; }
        marked.forEach(node => {
          if (node.getAttribute('data-lb-nc-text') !== field.field || node.querySelector('lb-native-value') || node.closest('lb-native-value')) return;
          const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT); let text;
          while ((text = walker.nextNode())) {
            if (!ownedPath(text.parentElement, node, rule.dataset.lbNativeOwner) || text.parentElement.closest(protectedText)) continue;
            let boundary = text.parentElement, foreignField = false;
            while (boundary && boundary !== node) { if (['data-lb-nc-text','data-lb-nc-html'].some(key => boundary.hasAttribute(key) && boundary.getAttribute(key) !== field.field)) { foreignField = true; break; } boundary = boundary.parentElement; }
            if (foreignField) continue;
            if (normalize(original(text,'text')) === normalize(field.original)) want(text,'text',field.mobile || '');
          }
        });
      }
      }
    });
    leaseScope = null;
    document.querySelectorAll('lb-native-image[data-lb-native-sizes-desktop] img').forEach(img => {
      const marker = img.closest('lb-native-image');
      const context = mediaContext(marker);
      if (context?.field && mediaTarget(img, context.section, context.owner, context.field, 'sizes')) want(img, 'sizes', marker.dataset[phone.matches ? 'lbNativeSizesMobile' : 'lbNativeSizesDesktop']);
    });
    function read(node,key) { return key === 'text' ? node.nodeValue : key === 'html' ? node.innerHTML : key === 'textContent' ? node.textContent : node.getAttribute(key); }
    function write(node,key,value) { if (read(node,key) === value) return; if (key === 'text') node.nodeValue=value; else if (key === 'html') node.innerHTML=value; else if (key === 'textContent') node.textContent=value; else if(value===null) node.removeAttribute(key); else node.setAttribute(key,value); }
    applied.forEach((props,node) => { props.forEach((entry,key) => { if(skipDetail(node,key)) { if(!node.isConnected) props.delete(key); return; } if (detailHandoffs.get(node)?.get(key)?.rejected) { props.delete(key); return; } if (!node.isConnected || !desired.get(node)?.has(key)) { if (read(node,key)===entry.value) write(node,key,entry.original); props.delete(key); } }); if (!props.size) applied.delete(node); });
    desired.forEach((props,node) => { if(!applied.has(node)) applied.set(node,new Map()); const old=applied.get(node); props.forEach((value,key) => { const entry=old.get(key)||{original:read(node,key)}; entry.value=value;old.set(key,entry);write(node,key,value); }); });
    window.lbPartDesign?.refresh();
    if (Array.from(detailSkipped).some(([node, keys]) => node.isConnected && Array.from(keys).some(key => !detailOwns(node, key)))) {
      if (detailRetry) schedule();
      else { detailRetry = true; try { refresh(); } finally { detailRetry = false; } }
    }
  }
  function schedule() { if(!queued) {queued=true; requestAnimationFrame(refresh);} }
  function detailContextCurrent(node, key, context) {
    const {rule, section, scope, owner, field, config} = context;
    if (!node.isConnected || rule.textContent !== config || ownRoot(rule) !== section || rule.getAttribute('data-lb-native-owner') !== owner || !ownerScope(rule).includes(scope) || !(node === scope || scope.contains(node))) return false;
    return node.getAttribute?.('data-lb-nc-owner') === owner && node.getAttribute('data-lb-nc-' + key) === field && mediaTarget(node, section, owner, field, key);
  }
  function detailReleased(node, key, release) {
    if (!node || typeof node !== 'object' || typeof key !== 'string') return;
    const keys = detailLeases.get(node), context = keys?.get(key);
    if (!context || detailOwns(node, key)) return;
    keys.delete(key);
    if (!keys.size) detailLeases.delete(node);
    const restored = !!release && typeof release === 'object' && release.restored === true && Object.prototype.hasOwnProperty.call(release, 'original') && node.isConnected && node.getAttribute(key) === release.original;
    if (!detailHandoffs.has(node)) detailHandoffs.set(node, new Map());
    detailHandoffs.get(node).set(key, {original:restored ? release.original : null, context, rejected:!restored});
    if (!restored) {
      const props = applied.get(node);
      props?.delete(key);
      if (props && !props.size) applied.delete(node);
    }
    if (restored && phone.matches && detailContextCurrent(node, key, context)) schedule();
  }
  window.lbNativeContent={refresh,owns:(node,key)=>applied.get(node)?.has(key)||false,detailReleased};
  refresh();
  phone.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','href','placeholder','data-lb-native-classes-desktop','data-lb-native-classes-mobile']});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
})();
